<template>
  <div>
    <transition name="accordion" @before-enter="beforeEnter" @enter="enter" @leave="leave">
      <div v-if="expandedInternal" ref="panel" class="search-container p-3" style="background-color: #f8f9fa;">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, nextTick, getCurrentInstance } from 'vue';

const instance = getCurrentInstance();

const props = defineProps({
  modelValue: Boolean,
  getTableElement: Function // ← 関数として受け取る
});
const emit = defineEmits(['update:modelValue']);

const panel = ref(null);
const expandedInternal = ref(props.modelValue);

watch(() => props.modelValue, val => expandedInternal.value = val);
watch(expandedInternal, val => emit('update:modelValue', val));

const adjustTableHeight = () => {
  const tableEl = props.getTableElement?.() || instance?.proxy?.$parent?.$refs?.tableWrapper;
  const topFixArea = document.querySelector('.top-fix-area'); // ←これ！

  if (!tableEl || !topFixArea) return;

  const pagination = document.querySelector('.pagination-container');
  const windowHeight = window.innerHeight - 100;
  const topFixHeight = topFixArea.offsetHeight;
  const paginationHeight = pagination?.offsetHeight || 0;
  const margin = 80;
  const newMaxHeight = windowHeight - topFixHeight - paginationHeight - margin;

  // あまりにも小さくならないように
  if (newMaxHeight < 100){
    tableEl.style.maxHeight = '100px';
  } else {
    tableEl.style.maxHeight = `${newMaxHeight}px`;
  }
};

watch(expandedInternal, () => {
  nextTick(() => {
    adjustTableHeight();
    setTimeout(() => adjustTableHeight(), 500);
  });
});

onMounted(() => {
  window.addEventListener('resize', adjustTableHeight);
  // 少し遅らせてから adjustTableHeight を実行
  nextTick(() => {
    setTimeout(() => {
      adjustTableHeight();
    }, 100); // ← DOMの描画完了を少し待つ
  });
});

const beforeEnter = (el) => { el.style.height = '0'; };
const enter = (el) => {
  el.style.transition = 'height 0.3s ease';
  requestAnimationFrame(() => { el.style.height = el.scrollHeight + 'px'; });
};
const leave = (el) => {
  el.style.transition = 'height 0.3s ease';
  el.style.height = el.scrollHeight + 'px';
  requestAnimationFrame(() => { el.style.height = '0'; });
};
</script>

<style scoped>
.accordion-enter-active,
.accordion-leave-active {
  overflow: hidden;
  transition: height 0.3s ease;
}
</style>
